import React, {Component} from 'react';
import PropTypes from 'prop-types';

import {t} from 'l10n';

import '../sass/page-navigation.scss';

class Pagination extends Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    render() {
        let currentPage = parseInt(this.props.currentPage),
            itemsPerPage = parseInt(this.props.itemsPerPage),
            totalCount = parseInt(this.props.totalCount);

        let {urlFn, onClick, pageNumLimit} = this.props;

        const maxPages = 3;

        let lastPage = Math.ceil(totalCount / itemsPerPage);

        if (lastPage == 1) return null;

        if (pageNumLimit) lastPage = Math.min(lastPage, pageNumLimit);

        let firstPage = lastPage > 1 ? Math.max(2, currentPage - Math.floor(maxPages / 2)) : 1;
        let finalPage = lastPage > 1 ? Math.min(lastPage-1, currentPage + Math.floor(maxPages / 2)) : 1;

        let page, links = [];

        let restProps = {urlFn, onClick, currentPage};

        if (firstPage > 1) {
            for (page = firstPage; page <= finalPage; page++) {
                links.push(<PaginationItem page={page} key={page} {...restProps}/>);
            }
        }

        // todo: revise firstPage == 3 and finalPage == lastPage - 2 condition lines
        // todo: l10n


        return (
            totalCount ?
                <div>
                    <div className="page-navigation mobile-hide">
                        {currentPage > 1 && <PaginationItem page={currentPage-1} className="left-page" showPage={false} {...restProps}/>}
                        <PaginationItem page={1} {...restProps}/>

                        {firstPage == 3 && <PaginationItem page={2} {...restProps}/>}
                        {firstPage > 3 && <div className="three-dots">...</div>}

                        {links}

                        {finalPage == lastPage - 2 && <PaginationItem page={lastPage-1} {...restProps}/>}
                        {finalPage < lastPage - 2 && <div className="three-dots">...</div>}

                        {lastPage > finalPage && <PaginationItem page={lastPage} {...restProps}/>}
                        {currentPage < lastPage && <PaginationItem page={currentPage+1} showPage={false} className="right-page" {...restProps}/>}
                    </div>
                    <div className="page-navigation mobile-show">
                        {currentPage > 1 && <PaginationItem page={currentPage-1} showPage={false} className="left-page" {...restProps}/>}
                        <div className="three-dots">{t('%1 of %2', currentPage, lastPage)}</div>
                        {currentPage < lastPage && <PaginationItem page={currentPage+1} showPage={false} className="right-page" {...restProps}/>}
                    </div>
                </div> : null
        )
    }
}

Pagination.propTypes = {
    currentPage: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    itemsPerPage: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    totalCount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    pageNumLimit:PropTypes.number,
    urlFn: PropTypes.func,
    onClick: PropTypes.func
};

Pagination.defaultProps = {
    currentPage: 1,
    urlFn: null,
    onClick: null
};

import { Link } from 'components/ReactRouterDomLocalized';

function PaginationItem({onClick = null, urlFn = null, className = null, page, currentPage, showPage = true}) {
    let classNames = [];

    if (className) classNames.push(className);
    if (page === currentPage) classNames.push('active');

    let props = {className: classNames.join(' ')},
        children = showPage ? page : null;

    if (urlFn) {
        return (
            <Link
                to={urlFn(page)}
                {...props}
            >{children}</Link>
        )
    }

    return (
        <a
            onClick={onClick ? () => onClick(page) : null}
            {...props}
        >
            {children}
        </a>
    )
}

export default Pagination;


// WEBPACK FOOTER //
// ./src/components/Pagination.js